export const makeBold = (text: string): string => {
  return `<bold>${text}</bold>`;
};

export const makeItalic = (text: string): string => {
  return `<italic>${text}</italic>`;
};
